<template>
  <a-modal
    title="现金支付"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="id" :labelCol="labelCol" :wrapperCol="wrapperCol" v-show="false">
          <a-input :disabled="showable" v-decorator="['id']" />
        </a-form-item>
        <a-form-item
          label="费用名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['coustName', {rules: [{required: true, message: '请输入费用名称'}]}]" />
        </a-form-item>
        <a-form-item
          label="数量"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input-number
            :precision="2"
            style="width: 100%"
            :min="0"
            @change="quantitySum"
            :disabled="showable"
            placeholder="请输入数量"
            v-decorator="['quantity', {rules: [{required: true, message: '请输入数量'}]}]" />
        </a-form-item>
        <a-form-item
          label="单位"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['unit', {rules: [{required: true, message: '请输入单位'}]}]" />
        </a-form-item>
        <a-form-item
          label="单价"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input-number
            :precision="3"
            style="width: 100%"
            :min="0"
            @change="priceSum"
            :disabled="showable"
            placeholder="请输入单价"
            v-decorator="['price', {rules: [{required: true, message: '请输入单价'}]}]" />
        </a-form-item>
        <a-form-item
          label="总金额"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :hidden="true"
        >
          <a-input-number
            :precision="2"
            style="width: 100%"
            :min="0"
            :disabled="showable"
            placeholder="请输入总金额(精确到分)"
            v-decorator="['amount', {rules: [{required: true, message: '请输入总金额(精确到分)'}]}]" />
        </a-form-item>
        <a-form-item
          label="备注"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['remark', {rules: [{required: true, message: '请输入备注'}]}]"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer">
      <div>
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="confirmLoading" type="primary" @click="handleOk">保存</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
export default {
  name: 'DailyOtherCostAdd',
  components: {},
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      editable: false,
      addable: false,
      theKey: 0,
      showable: false
    }
  },
  methods: {
    // 获取用户消息
    edit (child, type) {
      this.visible = true
      if (type === 'edit') {
        this.type = type
        this.theKey = child.key
      }
      if (type && type === 'add') {
        this.type = type
      }
      const {
        form: { setFieldsValue, resetFields }
      } = this
      if (type === 'add') {
        resetFields()
      } else if (type === 'edit') {
        const pickFiled = [
          'id',
          'coustName',
          'quantity',
          'price',
          'unit',
          'amount',
          'remark'
        ]
        this.$nextTick(() => {
          setFieldsValue(pick(child, pickFiled))
        })
      }
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 结束保存用户信息
    handleOk () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          if (this.type === 'add') {
            this.$emit('changeData', values)
          } else if (this.type === 'edit') {
            values.key = this.theKey
            this.$emit('editData', values)
          }
          this.visible = false
        }
      })
    },
    handleCancel () {
      this.visible = false
      setTimeout(() => {
        this.addable = false
        this.showable = false
        this.editable = false
      }, 200)
    },
    // 填写数量时触发
    quantitySum (e) {
      if (e !== null && e !== '' && e !== undefined) {
        const price = this.form.getFieldsValue(['price'])
        if (price.price !== undefined && price.price !== '' && price.price !== undefined) {
          this.form.setFieldsValue({ amount: (e * price.price).toFixed(2) })
        }
      }
    },
    // 填写单价时触发
    priceSum (e) {
      if (e !== null && e !== '' && e !== undefined) {
        const quantity = this.form.getFieldsValue(['quantity'])
        if (quantity.quantity !== undefined && quantity.quantity !== '' && quantity.quantity !== undefined) {
          this.form.setFieldsValue({ amount: (e * quantity.quantity).toFixed(2) })
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
